module.exports = __webpack_public_path__ + "static/img/6.68274ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/help/6.png
// module id = Rs5G
// module chunks = 0